<template>
  <v-container class="col-12">
    <v-card class="pa-4">
      <v-row class="mx-0">
        <v-select
          v-model="dateRange"
          :items="dateRangeList"
          label="Period"
          hide-details
          class="col-1"
          style="min-width: 250px"
        />
        <date-picker
          v-model="gameHistory.from"
          label="Date From"
          style="max-width: 240px"
          :show-time="true"
          :time-value="gameHistory.fromTime"
          @time-change="gameHistory.fromTime = $event"
        />
        <date-picker
          v-model="gameHistory.to"
          label="Date To"
          style="max-width: 240px"
          :show-time="true"
          :time-value="gameHistory.toTime"
          @time-change="gameHistory.toTime = $event"
        />

        <v-btn
          color="info"
          class="mt-3 ml-6"
          @click="search"
        >
          Search
        </v-btn>
        <export
          :fields="exportFields"
          :data="filteredItems"
          :reportName="'Game History'"
          :project="entity_id"
          :report="report"
          :without_sg="true"
        />
      </v-row>
    </v-card>
    <v-card class="pa-4 mt-4">
      <v-data-table
        :headers="tableHeaders"
        :items="filteredItems"
        :loading="gameHistory.loading"
        :options.sync="gameHistory.options"
        sort-by="created"
        sort-asc
        dense
        fixed-header
        @update:page="stickyHeaders(350)"
        :footer-props="{'items-per-page-options': [1000]}"
        :items-per-page="1000"
        style="z-index: 0; position: relative;"
        class="game-history-table"
      >
        <template v-slot:body.prepend>
          <tr class="grey lighten-3 game-history-table-filter-row">
            <td
              v-for="header in tableHeaders"
              :key="header.text"
            >
              <v-select
                v-if="gameHistory.filters.hasOwnProperty(header.value) && gameHistory.filters[header.value].type == 'select'"
                v-model="gameHistory.filters[header.value].data"
                hide-details
                dense
                small
                multiple
                clearable
                persistent-hint
                return-object
                single-line
                class="data-table-finance-filter-select"
                :items="columnValueList(header.value)"
              />
              <v-text-field
                v-if="gameHistory.filters.hasOwnProperty(header.value) && gameHistory.filters[header.value].type == 'text'"
                v-model="gameHistory.filters[header.value].data"
                class="data-table-finance-filter-textfield mx-0"
                hide-details
              />

              <v-autocomplete
                v-if="gameHistory.filters.hasOwnProperty(header.value) && gameHistory.filters[header.value].type == 'autocomplete'"
                v-model="gameHistory.filters[header.value].data"
                :items="columnValueList(header.value)"
                class="data-table-finance-filter-autocomplete ma-0 pa-0"
                clearable
                multiple
                hide-details
                return-object
                single-line
                persistent-hint
              >
                <template #prepend-inner>
                  <div class="text-no-wrap" style="margin-top: 6px">{{ header.text }} : {{ gameHistory.filters[header.value].data.length }}</div>
                </template>
                <template #selection="{select}">
                </template>
              </v-autocomplete>
            </td>
          </tr>
        </template>

        <template v-slot:item.amount="{ item }">
          <v-chip
            v-if="item.bigwin > 500 && item.amount > 0"
            color="yellow lighten-3"
          >
            {{ item.amount }}
          </v-chip>
          <template v-else>
            {{ item.amount }}
          </template>
        </template>

        <template v-slot:item.action="{ item }">
          <v-chip
            :color="transactionColor(item.action)"
          >
            {{ item.action }}
          </v-chip>
        </template>
        <template v-slot:item.external_id="{ item }">
          <div style="white-space: nowrap" v-if="item.round_id">RID: {{ item.round_id }}</div>
          <div style="white-space: nowrap" v-if="item.action_id">AID: {{ item.action_id }}</div>
        </template>

        <template v-slot:item.bonus="{ item }">
          <v-chip
            v-if="item.bigwin > 500 && item.bonus > 0"
            color="yellow lighten-3"
          >
            {{ item.bonus }}
          </v-chip>
          <template v-else>
            {{ item.bonus }}
          </template>
        </template>

        <template v-slot:item.diff="{ item }">
          <v-chip
            v-if="item.diff != 0"
            :color="getColor(item.diff)"
            dark
          >
            {{ item.diff }}
          </v-chip>
          <template v-else>
            {{ item.diff }}
          </template>
        </template>

        <template v-slot:item.game_name="{ item }">
          {{ item.game_name }} ({{ item.game_id }})
        </template>
        <template v-slot:item.created="{ item }">
          <span style="cursor: pointer" @click="copyToClipboard(item.created)">{{ item.created }}</span>
        </template>

        <template v-slot:item.info="{item}">
          <v-btn
            v-if="BET_TRANSACTION_TYPES.includes(item.action)"
            icon
            @click="getRawTransactionInfo(item.id)"
          >
            <v-icon v-text="'info'" />
          </v-btn>
        </template>

        <template v-slot:body.append>
          <tr>
            <td :colspan="tableHeaders.length">
              <v-divider />
            </td>
          </tr>
          <tr
            v-for="(row, index) in gameHistory.totalRows"
            :key="row.action + index"
          >
            <td
              v-for="(header, index) in tableHeaders"
              :key="header.text + index"
            >
              {{ row[header.value] }}
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog
      v-model="isAdditionalInfoVisible"
      max-width="900px"
    >
      <v-card
        class="px-3 pb-3"
        :loading="isLoadingTransactionInfo"
      >
        <v-card-title>
            Provider raw request
            <v-spacer />

            <v-btn style="margin-right: -30px; margin-top: -25px" icon @click="isAdditionalInfoVisible = false">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-card-title>
        <v-card-text>
            <pre style="white-space: break-spaces;">{{ getAdditionalInfoText() }}</pre>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<style>
  .data-table-finance-filter-select .v-select__selections {
    height: 32px;
    overflow: hidden;
    white-space: nowrap;
  }

  .data-table-finance-filter-select {
    max-width: 150px;
    font-size: 12px;
    padding: 0;
    margin: 0;
  }

  .data-table-finance-filter-textfield input {
    text-align: left;
  }

  .data-table-finance-filter-textfield {
    /*max-width: 80px;*/
    font-size: 12px;
    padding: 0;
    margin: 0;
  }

  .data-table-finance-filter-autocomplete {
    font-size: 12px;
    padding: 0;
    margin: 0;
  }

  .data-table-finance-filter-autocomplete .v-select__selections {
    height: 32px;
    overflow: hidden;
    white-space: nowrap;
  }

  .game-history-table td:first-child {
    border-left: thin solid rgba(0, 0, 0, 0.12);
  }

  .game-history-table th {
    white-space: nowrap;
  }

  .game-history-table th,
  .game-history-table td {
    padding: 5px 10px !important;
  }

  .game-history-table td {
    border-right: thin solid rgba(0, 0, 0, 0.12);
  }

  .game-history-table tr:last-child td {
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
  }

  .game-history-table .game-history-table-filter-row td {
    text-align: center;
    border-right: none;
    border-left: none;
    padding: 5px 3px !important;
  }

  .game-history-table .game-history-table-filter-row .v-input {
    margin: 0 auto !important;
  }

  .game-history-table .v-data-footer > div:first-child {
    margin-left: auto;
  }
</style>

<script>
  import { mapGetters } from 'vuex'
  import { mask } from 'vue-the-mask'
  import 'sticky-table-headers'
  import { map } from 'lodash'
  import { filters } from '@/utils/filters'
  import { API } from '@/utils/api'
  import DatePicker from '@/components/core/DatePicker/DatePicker.vue'
  import { makeDateRangeComputed } from '../utils'

  export default {
    directives: {
      mask,
    },

    components: {
      DatePicker,
      Export: () => import('@/components/helper/Export')
    },

    props: [],
    data: () => ({
      dateRangeList: global.dateRangeList,
      // transactions: [],
      headers: [
        { text: 'Created', value: 'created' },
        { text: 'ID', value: 'id', sortable: true, align: 'left' },
        { text: 'ParentID', value: 'parent_id', sortable: true },
        { text: 'Brand', value: 'brand' },
        { text: 'Game', value: 'game_name' },
        { text: 'Amount', value: 'amount' },
        { text: 'Balance', value: 'balance' },
        { text: 'Bonus', value: 'bonus' },
        { text: 'Bonus Balance', value: 'bonus_balance' },
        { text: 'Rollover', value: 'rollover' },
        { text: 'ExtID', value: 'external_id' },
        { text: 'Action', value: 'action' },
        { text: 'Difference', value: 'diff' },
      ],

      BET_TRANSACTION_TYPES: ['bet', 'win', 'lost', 'cashout', 'refund', 'rollback'],
      isAdditionalInfoVisible: false,
      rawTransactionInfo: null,
      isLoadingTransactionInfo: false,
    }),

    computed: {
      entity_id: function () {
        let entity = this.$store.state.auth.getEntityByLogin(this.activeAccount.account.login)
        return entity.entity_id
      },
      report: function () {
        return Object.assign({
          url: '/$v/account/game_history/list.json',
          from: this.gameHistory.from,
          to: this.gameHistory.to,
          account_id: this.activeAccount.account_id,
          login: this.activeAccount.account.login,
          entity_id: this.entity_id
        }, this.gameHistory.options)
      },
      exportFields: function () {
        return map(this.headers, 'value')
      },
      ...mapGetters({ activeAccount: 'account/active', gameHistory: 'account/gameHistory' }),
      filteredItems: function () {
        return filters(this.gameHistory.items, this.gameHistory.filters)
      },
      canViewAdditionalData() {
        return this.$store.state.auth.checkAccess({key: 'game_history_raw', value: true})
      },
      tableHeaders() {
        return [
          ...this.headers,
          ...(this.canViewAdditionalData ? [{ text: '', value: 'info' }] : [])
        ]
      },

      dateRange: makeDateRangeComputed('gameHistory'),
    },

    watch: {
      'gameHistory.options.page' (val) {
        if (window.pageYOffset > 250) {
          window.scrollTo(0, 250)
        }
      }
    },

    mounted () {
      this.stickyHeaders()
    },

    methods: {
      lengthOfSelectedGames (value) {
        return `Game: ${this.gameHistory.filters[value].data.length}`
      },
      stickyHeaders () {
        global.jQuery('.game-history-table table').stickyTableHeaders()
      },

      transactionColor (action) {
        let colorMap = {
          deposit: 'green lighten-3',
          withdraw: 'amber lighten-3',
          bonus_deposit: 'light-green lighten-4',
          bonus_withdraw: 'deep-orange lighten-4',
          bet: 'deep-purple lighten-5',
          win: 'teal lighten-5',
        }

        return colorMap[action] || ''
      },

      getColor (value) {
        if (value != 0) {
          return 'red'
        } else {
          return 'green'
        }
      },


      copyToClipboard: function (text) {

        let el = document.createElement('textarea')
        el.value = text
        el.setAttribute('readonly', '')
        el.style = { position: 'absolute', left: '-9999px' }
        document.body.appendChild(el)
        el.select()
        document.execCommand('copy')
        document.body.removeChild(el)
      },

      search: function () {
        this.$store.dispatch('account/loadGameHistory', this.activeAccount.account).catch(e => {
          this.$notification.show = true
          this.$notification.message = e.response.data.message
          this.$notification.type = 'error'
        })
      },

      columnValueList (val) {
        return this.gameHistory.items.map(d => d[val])
      },

      getRawTransactionInfo(id) {
        this.isAdditionalInfoVisible = true
        this.isLoadingTransactionInfo = true
        const [systemId, betTransactionId] = id.split('.')

        return API.call('/$v/account/game_history/bet_transaction_info.json', {
          system_id: systemId,
          bet_transaction_id: betTransactionId,
        }, this.activeAccount.account).then(r => this.rawTransactionInfo = r.data.result)
        .finally(() => this.isLoadingTransactionInfo = false)
      },

      getAdditionalInfoText() {
        if (this.isLoadingTransactionInfo) {
          return 'Loading'
        }

        if (!this.rawTransactionInfo) {
          return 'No raw data'
        }

          let raw = this.rawTransactionInfo
          try {
              raw = JSON.stringify(JSON.parse(raw), null, 4)
          } catch (e) {
          }
          return raw
      }
    },
  }
</script>
